import React from 'react';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import TextVariables from '../../../classes/TextVariables';

export default function UITextDescription(props)
{
	let properties = {
		'visible': {
			type: 'toggle',
			default: true
		},
		'description': {
			type: 'textarea',
			default: 'Description Text'
		},
		'text color': {
			type: 'color',
			default: '#ffffff'
		},
		'text alpha': {
			type: 'range',
			default: '80',
			step: 1,
		},
		'background color': {
			type: 'color',
			default: props.bgColor ? props.bgColor : '#4f4f4f'
		},
		'background alpha': {
			type: 'range',
			default: props.bgAlpha ? props.bgAlpha : '80',
			step: 1,
		},
		'shadow color': {
			type: 'color',
			default: '#000000'
		},
		'shadow alpha': {
			type: 'range',
			default: '80',
			step: 1,
		},
		'preset': {
			type: 'text-area-preset',
			default: props.preset ? props.preset : 'headers-bottom'
		},
		'text alignment': {
			type: 'align',
			default: 'left'
		},
		'font size': {
			type: 'font-size',
			default: '24'
		},
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Text Description'}
				subcomponent={types.TEXT_DESCRIPTION}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const data = props.data;
		const textColor = data['text color'].value;
		const textOpacity = data['text alpha'].value;
		const fontSize = data['font size'].value;
		const alignment = data['text alignment'].value;

		if(data['visible'].value !== true) return null;

		return (
			<div className={['uiTextBox', data['preset'].value].join(' ')}
				data-name={"ui-preview-text-description"}
				data-alignment={alignment}
				style={{
					backgroundColor: data['background color'].value + percentToHex(data['background alpha'].value),
					borderColor: data['shadow color'].value + percentToHex(data['shadow alpha'].value),
					//overflowY: 'scroll'
				}}
			>
				{
					data['description'].value?.split(/\r\n|\n|\r|\\n|\\r|\\r\\n/).map((line, idx) =>
					{
						if(!line || line === "") 
						{
							return (<br key={idx}/>)
						}
						else 
						{
							return (
								<div key={idx}
									style={{
										fontSize: fontSize + 'px',
										color: textColor,
										opacity: textOpacity / 100,
									}}
								>
									{TextVariables.textToData(line)}
								</div>
							);
						}

					})
				}
			</div>
		);
	}

	return null;
}